<template>
  <div class="space-y-2" v-if="isForSale && price">
    <h4 class="text-base font-medium block">
      {{ $t("artwork_details.list_price") }}
    </h4>

    <div class="space-y-2 text-sm">
      <div v-if="price" class="flex flex-wrap items-center space-x-2">
        <span class="font-normal">{{ $t("artwork_details.price") }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span>
          <span class="font-medium">{{ price.toLocaleString() }} </span>
          {{ $t("artwork_details.currencey_amd") }}
        </span>
      </div>
      <div class="flex flex-wrap items-center space-x-2">
        <span class="font-normal">{{
          $t("artwork_details.sale_availability")
        }}</span>
        <span class="border border-dashed border-gray-200 flex-1"></span>
        <span
          >{{
            isForSale
              ? $t("artwork_details.status_available")
              : `artwork_details.status_private`
          }}
        </span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const props = defineProps<{
  price: number;
  isForSale: boolean;
}>();
</script>
